import request from '@/utils/ai-request'

/**
 * 获取场景列表
 */
export function getScenarioList(params) {
  return request({
    url: '/scenarios',
    method: 'get',
    params
  })
}

/**
 * 获取场景详情
 */
export function getScenarioDetail(id) {
  return request({
    url: `/scenarios/${id}`,
    method: 'get'
  })
}

/**
 * 创建场景
 */
export function createScenario(data) {
  return request({
    url: '/scenarios',
    method: 'post',
    data
  })
}

/**
 * 更新场景
 */
export function updateScenario(id, data) {
  return request({
    url: `/scenarios/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除场景
 */
export function deleteScenario(id) {
  return request({
    url: `/scenarios/${id}`,
    method: 'delete'
  })
}

/**
 * AI生成场景
 */
export function generateScenario(data) {
  return request({
    url: '/scenario-generation/generate',
    method: 'post',
    data
  })
}

/**
 * 保存生成的场景
 */
export function saveGeneratedScenario(data) {
  return request({
    url: '/scenario-generation/save',
    method: 'post',
    data
  })
}

/**
 * 获取场景权限配置列表
 */
export function getScenarioAuths(id) {
  return request({
    url: `/scenarios/${id}/auths`,
    method: 'get'
  })
}

/**
 * 为场景配置权限（批量添加）
 */
export function addScenarioAuths(id, data) {
  return request({
    url: `/scenarios/${id}/auths`,
    method: 'post',
    data
  })
}

/**
 * 删除场景的所有权限配置
 */
export function deleteScenarioAuths(id) {
  return request({
    url: `/scenarios/${id}/auths`,
    method: 'delete'
  })
}
